import React from 'react';
import _ from 'lodash';
var highlightTerm = function highlightTerm(text, term) {
  if (_.isEmpty(term)) {
    return text;
  }
  var pattern = new RegExp(term.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'gi');
  var a = text.split(pattern);
  var r = text.match(pattern);
  if (!r) {
    return text;
  }
  var comp = _.reduce(a, function (acc, val, index) {
    return _.concat(acc, _.concat(val, r[index] ? /*#__PURE__*/React.createElement("b", {
      key: index
    }, r[index]) : null));
  }, '');
  return _.compact(comp);
};
export default highlightTerm;